import classNames from 'classnames';
import React from 'react';
import LoaderSvg from 'images/v5/icons/loader.svg';
import styles from './Loader.module.scss';
function Loader({ size = 'l', noMargin, fullViewport, overlay, }) {
    const wrapClasses = classNames(styles.wrap, styles[size], {
        [styles.noMargin]: noMargin,
        [styles.fullViewport]: fullViewport,
        [styles.overlay]: overlay,
    });
    const loaderClasses = classNames(styles.loader, styles[size], { [styles.svgOverlay]: overlay });
    return (React.createElement("div", { className: wrapClasses },
        React.createElement("span", { className: loaderClasses },
            React.createElement(LoaderSvg, null))));
}
export default Loader;
